import PersonProfileDao from '../dao/person-profile.dao';
import type { Environment } from '../interfaces/environment';

export abstract class PersonProfileService {
  static async getProfileById(env: Environment, personId?: number) {
    return !personId
      ? Promise.reject(new Error('Invalid id'))
      : await PersonProfileDao.getProfileById(env, personId);
  }

  static async getLiteProfileById(env: Environment, personId?: number) {
    return !personId
      ? Promise.reject(new Error('Invalid id'))
      : await PersonProfileDao.getLiteProfileById(env, personId);
  }

  static async getProfileAvatar(env: Environment, personId: number, size = 50) {
    return !personId
      ? Promise.reject(new Error('Invalid id'))
      : await PersonProfileDao.getProfileAvatar(env, personId, size);
  }

  static async getLiteProfileWithAvatar(
    env: Environment,
    personId?: number,
    size = 50
  ) {
    if (!personId) {
      return Promise.reject(new Error('Invalid id'));
    }

    const personProfile = await PersonProfileService.getLiteProfileById(
      env,
      personId
    );

    const image = await PersonProfileService.getProfileAvatar(
      env,
      personId,
      size
    );

    return {
      ...personProfile,
      avatar: `data:image/jpeg;base64,${image}`,
    };
  }
}
